<template>
  <div class="swiper-container">
      <div class="swiper-wrapper"  >
          <slot></slot>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination" :class="paginateCls" v-if="showPaginate"></div>
      <div class="swiper-scrollbar" :class="scrollbarCls" v-if="showScrollbar"></div>
  </div>
</template>
<script>
  import Swiper from './index'

  export default {
    props: {
      config: Object,
      showSinglePaginate: {
        default: false
      },
      paginateCls: {
        default: null
      },
      scrollbarCls: {
        type: Object,
        default: null
      },
      showPaginate: {
        type: Boolean,
        default: true
      },
      showScrollbar: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        // showPaginate: true
      }
    },
    mounted(){
      this.swiper = new Swiper(this.$el, this.config)
      this.$emit('swiper', this.getInstance())

      // const bullets = document.querySelectorAll('.swiper-pagination-bullet')
      // console.log(bullets, bullets.length, "swiper bullets")
      // if (!this.showSinglePaginate && bullets.length === 1) {
      //   this.showPaginate = false
      // }

    },
    methods: {
      getInstance () {
        // return this.swiper
        return this[`swiper${this.guid}`]
      }
    }
  }
</script>
<style lang="stylus" src="./index.styl">
</style>



// WEBPACK FOOTER //
// index.vue?f0843116